import { AppRecord } from '../../types';

/** Cannot open apps on web */
const canOpenApp = async (app: AppRecord) => false;

export default canOpenApp;
